import * as React from 'react';
import { useContext, useState } from 'react';
import { AuthContext } from '../../_auth/AuthContext';
import { IChangeEventHandler } from '../../_types/nav';
import { Grid } from '@material-ui/core';
import { IObjectPolicy, IPolicyDefinition, IPolicyObject, PolicyObjectCN } from '../../_types/ewpolicy';
import Policy from './Policy';
import { GetObjectPolicies, GetPermissionLazyLoad, GetPolicyDefinitions } from '../../_service/ewpolicy';

interface Props {
    onChange: IChangeEventHandler<IObjectPolicy>;
    policyObject: IPolicyObject;
};




const Policies: React.FC<Props> = (prop: Props) => {

    const { user } = useContext(AuthContext);
    const [cDef, setcDef] = useState<IPolicyDefinition[] | null>(null);
    const [policies, setPolicies]  = useState<IObjectPolicy[] | null>(null);

    //Attempt to init user from cookie
    React.useEffect(() => {
    
        let cn: string = PolicyObjectCN(prop.policyObject.objectType);
        //can the current user manage permissions
        GetPermissionLazyLoad(user, { policy_cn: "policy.user.manage_permissions", term: "yn"});

        //get policy definitions up front
        GetPolicyDefinitions(cn).then(r => {
    
            setcDef(r);

            GetObjectPolicies(prop.policyObject.id!, cn).then(p => {
            
                setPolicies(p);
            });
        });        

    }, []);

    React.useEffect(() => {
    
        let cn: string = PolicyObjectCN(prop.policyObject.objectType);

        //get policy definitions up front
        GetPolicyDefinitions(cn).then(r => {
    
            setcDef(r);

            GetObjectPolicies(prop.policyObject.id!, cn).then(p => {
      
                setPolicies(p);
            });
        });        

    }, [prop.policyObject]);

    const _canEditPolicy = ():boolean => {
        let toReturn: boolean = false;

        if (user.policies) {
            
            let match = user.policies.find(g => g.policy_cn === "policy.user.manage_permissions" && g.term === "yn");
            if (match) {
                toReturn = match.value === "1";
            }
        }
        
        return toReturn;
    }


    const _changePolicy = (c: IObjectPolicy) => {

        let inEdit: boolean = c.editing === true;
    
        setPolicies((prv) => {
            let newPrv: IObjectPolicy[] = [];

            prv?.forEach((e) => { 
                e.disabled = (e.policy_cn != c.policy_cn) && inEdit;

                

                if (c.policy_cn === e.policy_cn) {
                  
                    newPrv.push(c);
                } else {
                    newPrv.push(e);
                }

                
            });
            

            return newPrv;
            
        });

        prop.onChange(c);
    }

return (

    <Grid container direction="column" justify="flex-start" alignItems="stretch">
        {policies && cDef && policies.map((c, i) => {
            let policy_def = cDef.find(g => g.policy_cn == c.policy_cn);
            if (policy_def != null) {
            return (
                <Policy key={i} definition={policy_def} onChange={_changePolicy} policyObject={prop.policyObject} policy={c} allowEdit={_canEditPolicy()} ></Policy>
            )
            } else { return (<span></span>)}
        })}
    </Grid>

    )
}

export default Policies;